import { Sentiment } from "../api/transcriptions";

export enum EventSubscription {
  None = 0, Add = 1, Clean = 2
}

export const SERVER_PBX_MOBILE = 'MPBX'
export const SERVER_DATE_FOMATE = 'YYYY-MM-DD HH:mm:ss'
export const SERVER_DATE_FOMATE_MILL = 'YYYY-MM-DD HH:mm:ss.SSSSSSS'
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'

export const ClientName = 'IPFX Web Contact Centre'

export enum Dirty {
  None = 0,
  Insert = 1,
  Edit = 2,
  Delete = 3,
  DeleteChildren = 4,
  StateUpdate = 5,
}

export enum EntityType {
  Other = 0,
  Agent = 1,
  Call_history = 2,
  Call = 3,
  Contact = 4,
  Department = 5,
  Extension = 6,
  Product = 7,
  Queue = 8,
  Region = 9,
  Server = 10,
  Voicemail = 11,
  Message = 12,
  User = 13,
  Basic_object_extension = 14,
  Basic_object_queue = 15,
  Basic_object = 16,
  Location = 17,
  Break_code = 18,
  Registration = 19,
  Basic_object_voicemail_count = 20,
  Folder = 21,
  Alert = 22,
  Wrapup_code = 23,
  Device = 24,
  Ocspresencegroup = 25,
  Participant = 26,
  Conference = 27,
  Contactgroup = 28,
  Callflowsettings = 29,
  Callerprofile = 30,
  Schedule = 31,
  Schedulehours = 32,
  Presencesettings = 33,
  Callflow = 34,
  Voicemailsetting = 35,
  Devicegroup = 36,
  Country = 37,
  Diallingrule = 38,
  Contactgroupmember = 39,
  Wildcard = 40,
  Partition = 41,
  Wrapupfolder = 42,
  Featureclass = 43,
  Extentioninitialisation = 44,
  Cgpresenceoverride = 45,
  Facebook_post = 46,
  Facebook_comment = 47,

  InstantMessage = 100
}

export enum ContactType {
  None = -1,
  Company = 0,
  Personal = 1,
  Customer = 2,
}

export enum Presence {
  None = -2000,
  WorkTime = -1000,
  Queue = -1,
  Available = 0,
  Meeting = 1,
  DoNotDisturb = 2,
  Away = 3,
  Gone = 4,
  Holiday = 5,
  SickLeave = 6,
  Break = 7,
  BusinessTrip = 8,
}

export enum ExtensionStatus {
  //CallEventType

  // application defined
  Invalid = 10001,
  None = 0,
  Swapped = 123,

  // system wide
  Ringing = 1,
  Answered = 2,
  Released = 3,
  OffHook = 5,
  Hold = 6,
  Dialed = 9
}

export enum ExtensionSubStatus {
  //CallSubEventType

  // application defined
  NoEvent = 10002,
  DecideOnContext = 10001,
  Invalid = 10001,

  // system wide
  Normal = 0,
  Hunting = 1,
  Recall = 2,
  ForwardAll = 4,
  ForwardBusy = 5,
  ForwardNoAnswer = 6,
  Transfer = 7,
  Conference = 8,
  Busy = 10,
  Disconnected = 11,
  Terminate = 12,
  Outgoing = 13,
  Pickup = 14
}

export enum DeviceGroupDestinationTypes {
  //dsDestinationTypes
  None = -7,
  Operator = 1,    //VM_T_OPERATOR
  Associate = 2,     //VM_T_ASSOCIATE
  MobilePhone = 3,   //VM_T_CELLPHONE
  Home = 4,          //VM_T_HOME
  Pager = 5,        //VM_T_PAGER
  Office = 6,
  Other = 8,
  AlertMobile = 9,
  Softphone = 11
}
export enum DeviceGroupType {
  //omDeviceGroupType
  None = -1,
  Default = 0,
  AlternateNumbers = 1,
  Desk = 2,
  Mobile = 3,
  DeskAndMobile = 4,
  Home = 5,
  AllDevices = 6,
  Other = 7,
  Associate = 8,
  MyDevices = 9
}

export enum DeviceType {
  None = 0,
  Extension = 1,
  Mobile = 2,
  Home = 4,
  Other = 8,
  Softphone = 16
}

export enum DeviceSubType {
  None = 0,
  PsAnalog = 1,
  VoiceMail = 3,
  Cruiser = 5,
  Digital = 10,
  MonitoredNumber = 30,
  UcdPilot = 31,
  HotLine = 50,
}

export enum PbxAction {
  Answer = 1,
  Dial = 2,
  Hangup = 4,
  BlindTransfer = 8,
  SupervisedTransfer = 16,
  CompleteTransfer = 32,
  CancelTransfer = 64,
  Hold = 128,
  CancelHold = 256,
  QueueResume = 512,
  QueueRetrieve = 1028,
  QueueHold = 2056,
  HoldFor = 4096,
  Pickup = 8192,
  Conference = 16384,
  Moniotor = 32768,
  PickupCall = 65536,
  Record = 131072,
  Intrude = 262144,
  SwitchHold = 524288
}

export enum CallState {
  None = -1,
  Unknown = 0,

  // Announcement message played in the voicemail
  AnnouncementPending = 1,
  AnnouncementAnswered = 2,
  AnnouncementReturn = 3,

  // extension
  ExtensionPending = 4,
  ExtensionAnswered = 5,
  ExtensionReleased = 6,
  ExtensionReturn = 7,

  // others
  Queueing = 8,
  Callback = 9,
  VmHandled = 10,
  /** when we are waiting for an extn to answer but we dont want to pull it back to the queue */
  ExtensionTransfer = 11,
  /** voicemail generates a call to trigger a broadcast for the client */
  CallInVoicemail = 12,
  /** when the extension we are transferring to has answered the call.  there is still a person in the colsultation hold position */
  ExtensionTransferAnswer = 13,

  // callback states
  /** caller is recording the message now */
  CallbackRecording = 14,

  // day/time schedules
  /** means that it is going to another destination apart from queue. */
  Unattended = 19,
  /** means that it is going to another destination apart from queue. */
  UnattendedPending = 20,
  /** means that it is going to another destination apart from queue. */
  UnattendedProcessing = 21,
  /** an agent has put it into the queue for holding. */
  QueueHold = 22,
  /** waiting for an agent */
  PendinginQueue = 23,
  /** waiting for a wrapup codes */
  WaitingForWrapup = 24,
  Pending = 25,
  Dialling = 26,
  Connected = 27,
  OutboundRinging = 29,
  OutboundOffHook = 30,
  Hold = 31,
  ConferenceCall = 95
}

export enum CallType {
  /** Incoming call to an extension */
  Incoming = 0,
  /** Incoming UCD call */
  Queue = 2,
  /** Outbound call made by an extension */
  Outgoing = 3,
  /** Caller wants someone to ring them back */
  Callback = 4,
}

export enum CallDeviceType {
  None = 0,
  Extension = 1,
  Mobile = 2,
  Home = 4,
  Other = 8,
  Softphone = 16
}
export enum QueueIconEnum {
  Closed = 0,
  Open = 1,
  Virtual = 2,
  Holiday = 3,
  Emergency = 4,
  NoAgents = 5,
  OpenWarning = 6,
  OpenAlert = 7,
}

export enum ComposeStyle {
  ComposeStyleNone = 0,
  ComposeStyleReply = 1,
  ComposeStyleReplyAll = 2,
  ComposeStyleForward = 3
}

export enum StatisticCallType {
  Unknown = 0,
  Inbound = 1,
  Outbound = 2,
  Queue = 3
}

export enum ChatAction {
  NoMessage = -1,
  Unkown = 0,
  ChatFromServer = 1,
  EndSession = 2,
  StateInitialResponse = 3,
  StateAgentName = 4,
  MessageTitleUpdate = 5,
  ServerDisconnected = 6,
  UserIsTyping = 8,
  MessageSendSuccess = 100,
  MessageSendFailed = 101,
  ChatFromClient = 102,
  ChatReadOnly = 103
}

export enum CTExtensionType {
  Agent = 0,
  Analog = 1,
  Port = 3,
  Digital = 10,
  Voice = 11,
  Data = 20,
  MonitoredNumber = 30,
  UcdQueue = 31,
  Isdn = 40,
  PhsHandset = 41,
  Hotline = 50
}

export enum UserLevel {
  ExternalIm = 31,
  ExternalCollaboration = 30,
  None = 20,
  Server = 10,
  IPFXTechnician = 9,
  MasterTechnician = 8,
  TemporaryInstaller = 7,
  Technician = 6,
  Administrator = 5,
  LocalAdministrator = 4,
  Supervisor = 3,
  PowerUser = 2,
  Operator = 1,
  User = 0
}

export type Identifier = Readonly<{
  id: string
  server: string
}>

export type QueueId = Identifier & Readonly<{
  type: 'queue'
}>

export type SquadId = Identifier & Readonly<{
  type: 'squad'
}>

export type QueueOrSquadId = QueueId | SquadId


export type QueueSquadType = 'queue' | 'squad'
export function isQueueId(id: QueueOrSquadId): boolean {
  return id.type === 'queue'
}

export function isSquadId(id: QueueOrSquadId): boolean {
  return id.type === 'squad'
}

export const getKey = ({ server, id }: Identifier) => `[${server}][${id}]`

export function getQueueOrSquadKey(id: QueueOrSquadId) {
  return getKey(id) + `[${id.type}]`
}

export type AgentKey = Readonly<{
  server: string
  queue: string
  agent: string | null
}>

export type QueueMode = 'auto' | 'manual'
// export type QueueStatus = 'open' | 'closed' | 'scheduled' | 'no agents' | 'holiday'

export type QueueStats = QueueId & Readonly<{
  icon: QueueIconEnum
  id: string
  server: string
  description: string
  mode: QueueMode
  status: string
  count: number
  time: number | null
  agents: number
  answer: number
  abandoned: number
  other: number
  agentStatus: number
  virtual: boolean
  voicemailCount: number
  ansQTimeTotal: number
  abnQTimeTotal: number
  toaster: QueueIconEnum
  hide: boolean
}>

export type Queue = QueueId & Readonly<{
  iD: string
  uRITarget: string
  launchURIOnAnswer: boolean
  description: string
  serverName: string
  forcedWrapup: boolean
}>

export type Squad = SquadId & Readonly<{
  description: string
}>

export type Agent = Readonly<Extension & {
  answered: number
  talkTime: number
  media: Media[]
  enabled: boolean
  access: number
  skill: number
  entryTime: number
  entryCount: number
}>

export type Extension = Identifier & Readonly<{
  name: string
  presence: Presence
  breakCode: number
  returnTime?: number
  startTime?: number
  deviceGroupType: DeviceGroupType
  status: ExtensionStatus
  subStatus: ExtensionSubStatus
  awayFromDesk: boolean
  waitingForWrapup: boolean
  extendedAvailablePresence: boolean
  tempLogout: boolean
  department: string
  regionId: string
  expertise: string
  operatorNotes: string
  activity: string[]
  imageImageDate?: string
  monitorDesk?: boolean
}>

export type ExtensionNumbers = Readonly<{
  associateNumber: string
  email: string
  homeNumber: string
  mobileNumber: string
  officeNumber: string
  otherNumber: string
  isMobileNumberVisible: boolean
  isHomeNumberVisible: boolean
  isOtherNumberVisible: boolean
}>

export type ExtensionDetails = Readonly<Partial<ExtensionNumbers & {
  monitor: boolean
  canReceiveVoicemail: boolean
}>>

export type MediaStatus = 'Queueing' | 'Processing' | 'Answered' | 'Wrapup' | 'Ringing'
export enum ClidObjectType {
  none = -1,
  extension = 0,
  queue = 1,
  speedDial = 2,
  personalContact = 3,
  companyContact = 4,
  customerContact = 5,
}

export enum ClidNumberType {
  none = -1,
  desk = 0,
  queue = 1,
  speedDial = 2,
  business = 3,
  mobile = 4,
  asociate = 5,
  home = 6,
  other = 7,
  email = 8,
}


export type Media = Readonly<{
  id: string
  deviceId: string
  status: CallState
  clid: string
  clidDescription: string
  connectedParty: string
  server: string
  queueId: string
  queueIdDescription: string
  dnis: string
  dnisDescription: string
  fullName: string
  elapsedTime: number //changed by status of call i.e. hold time if on hold, talk time if answered etc
  mediaType: MediaType
  wrapupFolder: string
  preferredExtn: string
  forwardFrom: string
  forwardReason: number
  callType: CallType
  isQueueCall: boolean
  deviceType: CallDeviceType
  recordStatus: number
  reason: string,
  notes: string,
  urgency: number,
  extensionId: string,
  deviceDescription: string
  devices?: readonly CallDevice[]
  subject: string
  extensionsWaitingForWrapup: string[]
  callTransactionId: string
  queuingTime: number
  heldTime: number
  talkTime: number
  wrapupTime: number
  inVmRecordingMessage: boolean
  preferredExtnDescription: string
  clidAccountCode: string
  clidNumberType: ClidNumberType
  clidObjectKey: string
  clidObjectType: ClidObjectType
  sourceApp: string

  isRecording: boolean
  voicemailPort: string //used to record the vmport the recording is out
  voicemailPortIsConnected: boolean
  voicemailPortIsSuppresed: CallSuppressType

  lastUpdateTime: number
  hide: boolean //used to hide toaster
  minimised: number //used to hide toaster
  taskId: string

  mediaItemId: string
  extensionEmail: string

  completed?: boolean
  dtmf: boolean
  window: boolean
}>

export type CallSuppressType = 'suppressed' | 'allowed' | 'recordingSuppressed'

export type CallDevice = Readonly<{
  number: string
  baseType: CallDeviceType
  description: string
  visible: boolean
}>

export type LocationType = Readonly<{
  id: number
  description: string
  defaultReturnTimeId: number
}>

export type Config = Readonly<{
  version: string
  ipAddress: string
  clientId: string
  serverName: string
  extension: string
  sessionPingTimeInterval: number
  presence: Readonly<Record<number | string | Presence, LocationType>>
  breakCodes: Readonly<Record<number, string>>
  regions: Region[]
  queueRegions: QueueRegion[]
  devices: ExtensionDevice[]
  baseUserLevel: UserLevel
  featureClassId: number
  primaryDevice: string
  currentDeviceGroup: DeviceGroup

  firstName: string
  lastName: string
  fullName: string

  officeExtension: string
  associateNumber: string
  mobile: string
  homeNumber: string
  otherNumber: string
  screenCapture: boolean

  vmExtensions: string[]

  canReceiveVoicemail: boolean

  access: Access

  agentDisplayName: ApplicationSetting
  wrapupSingleSelect: boolean

  agentStatistic: AgentStatistic | null

  agentLimits: AgentLimt[]

  dateTimeLongFormat: string
  dateTimeShortFormat: string
  shortTimeFormat: string
  longTimeFormat: string
  shortDateFormat: string
  longDateFormat: string

  command: CommandInfo[]
  vMPortExtensions: string[]

  rescheduleWrapupDuration: number

  defaultWorkTime: number

  requestId: string
  sessionId: string
  socketId?: string
  imEnabled: boolean
  imAllowBlockedMessagesSentAsEmails: boolean
  imBlockMessageInLocation: boolean

  taskStates: TaskState[]

  department: string
  regionId: string
  expertise: string
  siteSpecificExpertise: boolean

  applicationSettings: ApplicationSetting[]

  callAssistants: CallAssistant[]

  canMonitor: boolean
  teamsEnhancedCti: boolean

  preReleaseFeatures: string

  turnServer: string
  turnServerUdp: string
  turnServerTcp: string
  janus: string
  realm: string

  operatorNotes: string
  activity: string
  teamsEnhanced: boolean
  emailAttachmentPreview: string[]
  myQueues: string[]

  imageDateTime?: string

  clientDebugging: boolean
  transcriptionEnabled: boolean
  mediaQueueTwitter: boolean
  mediaQueueFacebook: boolean
  mediaQueueEmail: boolean
  mediaQueueWebChat: boolean
  autoLocnExpiry: boolean

  monitorGroups: MonitorGroup[]

  localServerTimeZoneBias: number
  showMainToolbar: boolean
}>

export type PopContactEvent = 'Ring' | 'Answer' | 'None'
export type PopContactBehaviour = 'Auto' | 'ContactSelection'

export type CrmSettings = {
  defaultCrmPage: string
  defaultNoContactResultPage: string
  integrationEnabled: boolean
  handleCallBacks: boolean
  handleDirectCalls: boolean
  popContactBehaviour: PopContactBehaviour
  popContactEvent: PopContactEvent
  popOutgoing: boolean
  popPhoneCall: boolean
}

export type MonitorGroup = Readonly<{
  extensionId: string
  monitorDesktop: boolean
}>

export type AgentLimt = Readonly<{
  type: MediaType
  wrapupTime: number
  heldTime: number
  talkTime: number
  totalTime: number
}>

export type AgentStatistic = Readonly<{
  extensionId: string
  pullBacks: number
  call: CallStatistic[]
  presence: Statistic[]
  custom: Statistic[]
}>

export type CallStatistic = Readonly<{
  type: StatisticCallType
  answeredCallCount: number
  ringTime: number
  talkTime: number
  holdTime: number
  wrapTime: number
  offHookTime: number
  totalCallTime: number
  wrappedUpCalls: number
  shortCalls: number
  longCalls: number
}>

export type Statistic = Readonly<{
  key: string
  value: number
}>

export type Access = Readonly<Partial<{
  isTeamsPbx: boolean
  isScreenRecording: boolean
  isLyncLicensed: boolean
  isCallRecordingLicensed: boolean
  canMonitor: boolean
}> & {
  features: Partial<Features>
}>

export type Features = Readonly<{
  extensionExtendedAvailablePresence: boolean
  toolbarConfiguration: boolean
  toolbarDashboard: boolean
  configQueues: boolean
  phoneDial: boolean
  phoneAnswer: boolean
  phoneHangup: boolean
  phoneXferBlind: boolean
  phoneXferSupervised: boolean
  phoneXferComplete: boolean
  phoneXferCancel: boolean
  phoneHold: boolean
  phoneResume: boolean
  phoneQueueHold: boolean
  phoneHoldFor: boolean
  phonePickup: boolean
  phoneConference: boolean
  phoneMonitor: boolean
  phoneIntrude: boolean
  phoneSwitchHold: boolean
  phoneHoldMessage: boolean
  phoneBusySetCallback: boolean
  phoneRetrieveCallFromVM: boolean
  phoneListenToCallInVM: boolean
  phoneSendCallToVM: boolean
  phoneSuppressRecord: boolean
  phoneRecord: boolean
  queuesRouting: boolean
  breakCodes: boolean
  configMyExtension: boolean
  configAllExtensions: boolean
  licensedEmpower: boolean
  queueItemsKill: boolean
  callShowCLID: boolean
  extensionMyLocation: boolean
  extensionAllLocations: boolean
  extensionViewOtherVoicemail: boolean
  workTime: boolean
  toolBarVoicemail: boolean
  toolbarCallHistory: boolean
  extensionSetDeviceGroups: boolean
  toolbarQueues: boolean
  extensionMyLocationSettings: boolean
  extensionPSChat: boolean
  extensionPSChatExternal: boolean
  toolbarDirectory: boolean
  companyContactsAccess: boolean
  directoryCompanyContactAdd: boolean
  directoryPersonalContactAdd: boolean
  directoryCompanyContactEdit: boolean
  directoryPersonalContactEdit: boolean
  directoryCompanyContactDelete: boolean
  directoryPersonalContactDelete: boolean
  reports: boolean
  extensionShortCuts: boolean
  clientViewExtensionDetails: boolean
  toolbarAssistance: boolean
  alertCallAssistant: boolean
  callAssistant: boolean
  extensionDeviceGroupsEditOwn: boolean
  extensionDeviceGroupsEditOthers: boolean
  licensedScreenCapture: boolean
  advancedSearch: boolean
  toolBarCollaboration: boolean
  monitorAgentDesktop: boolean
  crmIntegration: boolean
}>

export type ExtensionDevice = Readonly<{
  number: string
  baseType: DeviceType
  deviceSubType: DeviceSubType
  canReceiveVm: boolean
  tenant: number
  pbxActionBitMask: number
  description: string
}>

export type DeviceGroup = Readonly<{
  deviceGroupId: string
  extensionId: string
  description: string;
  available1Device1: number
  available1Device2: number
  available1Device3: number
  available2Device1: number
  available2Device2: number
  available2Device3: number
  playBackDevice: DeviceGroupDestinationTypes
  deviceGroupType: DeviceGroupType
}>

export type BreakCode = Readonly<{
  key: number
  value: string
}>

export type AdditionalConfig = Readonly<Partial<{
  favouriteQueuesFolderId: string
  favouriteExtensionFolderId: string
  favouriteContactFolderId: string
  shortcutFolderId: string
}>>

export type PresenceMap = Readonly<{
  presence: Config['presence']
  breakCodes: Config['breakCodes']
}>

export type VoiceMail = Readonly<{
  id: string
  caller: {
    id: string
    name: string
  }
  folder: VoiceMailFolder
  subject: string
  received: number
  duration: number
  type: VoiceMailType
  status: VoiceMailStatus
  urgent: boolean
  personal: boolean
}>

export enum VoiceMailType { Message, Fax, Email }
export enum VoiceMailStatus { Read, Unread, Deleted, Saved, None }
export type VoiceMailFolder = 'Inbox' | 'Deleted' | 'Sent' | 'Saved' | 'Future'

export function getPresenceText(presenceMap: PresenceMap, { presence, breakCode, returnTime }: Extension) {
  const name = presenceMap.presence[presence].description
  if (!name) { return '' }

  const br = presenceMap.breakCodes[breakCode]
  if (presence !== Presence.Break || !br) { return name }

  return `${name} (${br})`
}

export function getAgentKey(queue: Identifier, agent: string | null = null): AgentKey {
  return { server: queue.server, queue: queue.id, agent }
}

export const agentKeyToString = ({ server, queue, agent }: AgentKey) => JSON.stringify({ server, queue, agent })

export function parseAgentKey(json: string) {
  const { server, queue, agent } = JSON.parse(json) as AgentKey
  return { server, queue, agent }
}

export enum QueueRegionId {
  Squads = '{squads}',
  Mine = '{mine}',
  Favourites = '{fav}',
}

export type RegionHandle = Readonly<{
  server: string
  id: string
}>

export type Region = Readonly<{
  server: string
  id: string
  name: string
  countryCode: string
  localAreaCode: string
  nationalAccessCode: string
  localNumberLength: number
  timeBias: number
}>

export type QueueRegion = Region | QueueRegionId
export type QueueRegionHandle = RegionHandle | QueueRegionId

export function sameRegion(r1: QueueRegion, r2: QueueRegion) {
  if (typeof r1 === 'string' || typeof r2 === 'string') {
    return r1 === r2
  } else {
    return r1.server === r2.server && r1.id === r2.id
  }
}

export function sameIdentifier(i1: Identifier, i2: Identifier) {
  return i1.server === i2.server && i1.id === i2.id
}

export function sameQueueOrSquadId(id1: QueueOrSquadId, id2: QueueOrSquadId) {
  return id1.type === id2.type && sameIdentifier(id1, id2)
}

export type CallFolder = 'received' | 'placed' | 'missed'

export type Call = Readonly<{
  id: string
  from: {
    id: string
    name: string
  }
  folder: CallFolder
  subject: string
  date: number
  duration: number
  read: boolean
  mediaType: MediaType
  deviceType: DeviceType
  callKey: string
  mediaItemId: string
  queueId: string
  queue: string
}>

export type MediaType = '' | 'EMAIL' | 'TC' | 'CALL' | 'VM' | 'FB' | 'TWEET' | 'OUT' | 'EMAILAUTO' | 'EMAILATTACHMENTS' | 'DIRECTIONIN' | 'DIRECTIONOUT'

export type Command = Readonly<{
  Header: {
    To: {
      Application: string
    }
    From: {
      Application: string
    }
    TransactionId: string
  }
  RequestId: string
  CommandReason: number
  CommandType: 'INITIALISE' | 'SHUTDOWN'
  ExtendedInfo: CommandInfo
  Time: number //interface only
  Hide: boolean
}>

export type CommandInfo = Readonly<{
  Keys?: {
    DSLKey: string
    //user QueueItems.Key
    //SSKey: string
    ItemType: MediaType
    SessionID: string
  }
  KEYS?: {
    DSLKey: string
    //user QueueItems.Key
    //SSKey: string
    ItemType: MediaType
  }
  PPInitialise?: {
    CanDecline: string
    Timeout: number
    Key: string
    AgentDisplayName: string
  }
  PPINITIALISE?: {
    CanDecline: string
    Timeout: number
    Key: string
  }
  QueueItems: {
    Key: string
    QueueNumber: string
    QueueDescription: string
    Subject: string
    ForeignKey: string
    ContactDescription: string
    DialledNumberDescription: string
    ItemType: MediaType
    TimeQueued: number
  }
  Specific?: {
    SignatureTemplatePath: string
    UserProfileImageUrl: string
    UserScreenName: string
    ReceivedBy: string
    UserLocation: string
    UserFollowersCount: string
    UserDescription: string
    CreatedAtUtc: string
    UserId: string
    Subject: string
    CampaignId: string
    CampaignName: string
    ContactId: string
    ContactName: string
    PrimaryTelephoneNumber: string
    SecondaryTelephoneNumber: string
    EmailAddress: string
    Url: string
    ContactNote: string
  }
}>

export type Wrapup = Readonly<{
  id: string
  name: string
  folder: boolean
}>

export type ScriptItem = Readonly<{
  name: string
  html: string
}>

export type ScriptFolder = Readonly<{
  name: string
  items: ScriptItem[]
}>

export type ExtraCallData = Readonly<{
  id: string
  type: EntityType
  name: string
  company: string
  email: string
  phone: string
  mobile: string
  home: string
  department: string
}>

export enum QueuingState {
  None = -1,
  PendingQueueAssignment = 0,
  NotQueued = 1,
  Queued = 2,
  Handled = 3,
}


export type Email = Readonly<{
  clientPath: string
  id: string
  itemId: string
  originalId: string
  originalItemId: string
  subject: string
  sentAtUtc?: number
  receivedAtUtc: number
  conversationId: string
  from: Recipient
  sender: Recipient
  receivedBy: Recipient
  toRecipients: Recipient[]
  ccRecipients: Recipient[]
  attachments: Attachment[]
  body: string
  style: ComposeStyle
  extensionId: string
  extensionDescription: string
  isOutGoing: number
  isAnswered: number
  queueId: string
  queueDescription: string
  queuingState: QueuingState
  signatureTemplatePath: string
  defaultEmailFontFamily: string
  datastoreItemId?: string
}>

export type Attachment = Readonly<{
  id: string
  isInLine: boolean
  isItem: boolean
  contentId: string
  contentType: string
  name: string
  serverFilePath: string
  clientFilePath: string
  size: number
}>

export type Recipient = Readonly<{
  name: string
  address: string
}>

export enum EmailReplyType {
  New = 0,
  Reply = 1,
  ReplyAll = 2,
  Forward = 3,
}

export type CallHistoryEntry = Readonly<{
  id: string
  clid: string
  clidDescription: string
  date: number
  subject: string
}>

export type CallHistoryDetailsEntry = Readonly<{
  details: string
  notes: string
  releaseType: string
}>

export enum MediaHistoryIpfxType {
  None = 0,
  Contact = 1,
  Extension = 2,
}

export type MediaCallHistoryEntry = Readonly<{
  id: string
  receivedAtUtc: number
  extensionId: string
  extensionName: string
  queueId: string
  queueName: string
  subject: string
  conversationId: string
  mediaTypeId: MediaType
  mediaTypeName: string
  isOutgoing: boolean
  isAnswered: boolean
  folder: string
  notes: string
  taskSubject: string
  taskId: string
  lookupId: string
  ipfxId: string
  ipfxType: MediaHistoryIpfxType
  ipfxDescription: string
  accountId?: string
  dataSource: string
}>

export enum ChatMessageSource {
  Server = 1,
  Client = 2,
  Agent = 3,
}

export type ChatMessage = Readonly<{
  source: ChatMessageSource
  message: string
  created: number
}>

export type Outbound = Readonly<{
  contactId: string
  primaryTelephoneNumber: string
  secondaryTelephoneNumber: string
  emailAddress: string
  url: string
  contactName: string
  contactNote: string
  campaignId: string
  campaignName: string
  sessions: CampaignContactSessions[]
  codes?: DispositionCode[]
  selectedCode?: DispositionCode
  deferDate?: number
}>

export enum DispositionCodeAction {
  Close = 1,
  Delete = 2,
  Defer = 3,
}

export type DispositionCode = Readonly<{
  iD: string
  name: string
  description: string
  action: DispositionCodeAction
  deferMinutes: number
  canEditDeferDateTime: boolean
  isDeleted: boolean
  displayAfterDispositionCodeId?: string
}>

export type CampaignContactSessions = Readonly<{
  id: string
  contactId: string
  extensionId: string
  startedAtUtc?: number | string
  finishedAtUtc?: number | string
  dispositionCodeId: string
  dispositionAction: number
  deferredUntilUtc?: number | string
}>

export type FacebookPost = Readonly<{
  postId: string
  createdAtUtc: number
  type: string
  userId: string
  userName: string
  text: string
  linkUrl: string
  linkPicture: string
  linkName: string
  linkCaption: string
  linkDescription: string
  linkTitle: string
  pageId: string
  unRead: boolean
  comments: FacebookComment[]
}>

export type FacebookComment = Readonly<{
  commentId: string
  createdAtUtc: number
  userId: string
  userName: string
  text: string
  postId: string
  parentCommentId: string
  unRead: boolean
  extensionId: string
  attachmentType: string
  attachmentUrl: string
  attachmentTitle: string
  attachmentDescription: string
  attachmentImage: string
  replies: FacebookComment[]
}>

export type FacebookPage = Readonly<{
  pageId: string
  name: string
  url: string
}>


export type FileUploaded = {
  Name: string
  Size: number
  ServerFilePath: string
  ContentType: string
}

export type Task = Readonly<{
  taskId: string
  createdAtUtc: number
  createdBy: string
  subject: string
  contactId: number
  stateId: number
  lookupId: string
  items: TaskItem[] | undefined
}>

export enum TaskItemAction {
  none = 0,
  incoming = 1,
  outgoing = 2,
  queue = 3
}

export type TaskState = Readonly<{
  stateId: number
  name: string
}>

export type TaskItem = Readonly<{
  itemId: string
  mediaTypeId: MediaType
  action: TaskItemAction
  dateTimeUtc: number
  subject: string
}>

export type ContactBasic = Readonly<Identifier & {
  regionId: string
  extensionNumber: string
  description: string
  home: string
  business: string
  mobile: string
  email: string
}>

export enum ContactNumberType {
  None = 0,
  Business = 1,
  Mobile = 2,
  Home = 3,
  Other = 4,
}

//conacts need to be upper case so we can send back on the save
export type Contact = Readonly<{
  ServerName: string
  ContactId: number
  RegionId: string
  ExtensionNumber: string
  Description: string
  Home: string
  Business: string
  Mobile: string
  Email: string
  Other: string

  Priority: string
  CustomId: string
  Queue: string
  Notes: string
  Url: string
  PagId?: number
  LastAgentCalled: string
  SynchId: string
  SynchDate?: number
  ForeignKey: string
  JobTitle: string
  Department: string
  Company: string
  ImAddress: string
  ImagePath: string
  ImageDate?: string
  IsOutlook: boolean
}>

export type SettingType = 'ShowVirtualQueues' | 'ExtensionAutoAnswer' | 'ExtensionPresenceExpiry' | 'WebRtcEnabled' | 'AgentViewOnAnswer' | 'ShowShortcutsToolbar' | 'AwayFromDeskTimeoutSeconds'

export type ApplicationSetting = Readonly<{
  applicationSettingId: string
  applicationId: string
  settingType: string
  identifier: string
  value: string
  extensionId: string
  dirty: Dirty
  lastUpdated: number
}>

export type CallAssistant = Readonly<{
  callAssistantId: string
  ownerExtension: string
  targetExtension: string
  targetExtensionServer: string
  targetExtensionFullName: string
  targetExtensionDescription: string
  notifyInbound: boolean
  server: string
}>

export type BasicNotification = Readonly<{
  subject: string
  alertBody: string
  status: string
  imageKey: number
  time: number
}>

export type WebChat = Readonly<{
  chatId: string
  createdAtUtc: number
  queueId: string
  extensionId: string
  extensionName: string
  userId: string
  userName: string
  subject: string
  messages: WebChatMessages[]
}>

export type WebChatMessages = Readonly<{
  to: string
  from: string
  createdAtUtc: number
  message: string
}>

export type AgentViewTab = 'details' | 'tasks' | 'contact' | 'wrapups' | 'transcription' | ''

export type QueueView = {
  region: QueueRegion
  queue?: undefined
} | {
  region?: undefined
  queue: Identifier
}

export type Tweet = Readonly<{
  tweeterId: string
  userScreenName: string
  userId: string
  userLocation: string
  userFollowersCount: string
  userProfileImageUrl: string
  createdAtUtc: number
  subject: string
  receivedBy: string
  queueId: string
  replies?: TweetReply[]
}>

export type TweetReply = Readonly<{
  tweetId: string
  text: string
  createdAtUtc: number
  extensionId: string
  conversationId: string
}>

export function canRetrieveCall(items: Media[], extension: ExtensionStatus) {
  let calls = 0
  for (let index = 0; index < items.length; index++) {
    const item = items[index];
    calls = calls + ((item.mediaType === 'VM' || item.mediaType === 'CALL') ? 1 : 0)
    if (!((item.status === CallState.Queueing || item.status === CallState.ExtensionPending)
      && (((item.mediaType === 'VM' || item.mediaType === 'CALL') && (extension === ExtensionStatus.Released || extension === ExtensionStatus.None))
        || (item.mediaType !== 'VM' && item.mediaType !== 'CALL')))) {
      return false;
    }
  }

  if (calls > 1) return false
  return true;
}

export function canQueueResume(items: Media[], extension: ExtensionStatus) {
  let calls = 0
  for (let index = 0; index < items.length; index++) {
    const item = items[index];
    calls = calls + ((item.mediaType === 'VM' || item.mediaType === 'CALL') ? 1 : 0)
    if (!((item.status === CallState.QueueHold)
      && (((item.mediaType === 'VM' || item.mediaType === 'CALL') && (extension === ExtensionStatus.Released || extension === ExtensionStatus.None))
        || (item.mediaType !== 'VM' && item.mediaType !== 'CALL')))) {
      return false;
    }
  }

  if (calls > 1) return false
  return true;
}

export enum AccountType {
  Ews = 0,
  Smtp = 1
}

export type QueueEmail = Readonly<{
  queueId: string
  queueDescription: string
  signatureTemplatePath: string
  defaultEmailFontFamily: string
  emailAddress: string
  enabled: boolean

  accountId: string
  accountType: AccountType
  azureSearchEnabled: boolean
  azureSearchGroup: string

  //used to work out if this is a group or email account
  //only used in selectSearchEmailAccounts
  type?: number

  mediaId?: string
  id?: string
}>

export enum ConversationFlags {

  None = 0x0000,
  ConversationClosed = 0x0001,
  PrivateMessages = 0x0002,
  ConversationRemoved = 0x0004,
  OneToOneConversation = 0x0008,
  QueueConversation = 0x0010,
  DataStoreQueuedConversation = 0x0020,
  QueueConversationClosed = 0x0040,
  }

// this is internal ImConversation with extra info.
export type InstantMessageConversation = Readonly<{
  conversationId: string
  conversationTitle: string
  createdUtc?: number

  lastUpdatedUtc?: number
  conversationFlags: ConversationFlags
  deviceEndpoint: string
  unreadMessagesTotal: number
  unreadUrgentMessagesTotal: number
  lastUnreadMessage: string
  removedFromConversationTitle: string
  removedFromConversationTimestampUtc?: number
  participants: InstantMessageConversationParticipant[]
  currentUserId?: string
  oneToOneConversation?: boolean
  conversationViewOnly?: boolean
  messages?: ConversationMessage[]
  joined: InstantMessagerJoinState
  recipients: InstantMessageConversationRecipent[]

  createdStoreDateUtc: number

  script?: string
  userData?: string
}>

export function IsQueueConversation(conversation: InstantMessageConversation) {
  return (conversation.conversationFlags & ConversationFlags.QueueConversation) === ConversationFlags.QueueConversation
}

export enum InstantMessagerJoinState {
  none = 0,
  joining = 1,
  joined = 2,
}

export enum InstantMessagerDeviceStatus {
  Offline = 0,
  Online = 1,
  Unknown = 2,
  Disabled = 3
}

export enum InstantMessagerParticipantState {
  ParticipantStateUnknownInternalUseOnly = 0, // UI will never get this state
  ParticipantLeftConversation = 1,
  ParticipantInvitedIntoConversation = 2,
  ParticipantReEnteredConversation = 3,
  ParticipantEnteredConversation = 4,
  ParticipantInConversation = 5,
  ParticipantLostConnectionToConversation = 6,
  ParticipantInviteStage = 7
}

export enum InstantMessagerParticipantEndpointScheme {
  ipfx = 0,
  IpfxExtension = 1,
  IpfxContact = 2,
  IpfxEmailContact = 3,
}
export enum InstantMessagerConversationState {
  invitedintoconversation = 0,
  waitingforconversationaccept = 1,
  enteredconversation = 2,
  inconversation = 3,
  startedtyping = 4,
  stoppedtyping = 5,
  leftconversation = 6,
  setconversationtitle = 7,
  setendpointdisplayname = 8,
  rejectconversation = 9,
  dismissconversation = 10,
  closeconversation = 11,
  lostconnectiontoconversation = 12,
  connectionprobe = 13,
  connectionalive = 14,
  reenteredconversation = 15,
  removedfromconversation = 16,
  invitephase = 17,
  removedfromconversationandview = 18,
  removedfromlistview = 19,
  addedfromlistview = 20,
  alreadyinconversation = 21,
  alreadyleftconversation = 22,
  lostconnectiontoinviteconversation = 23,
  leftconversationininviteconversation = 24,
  badconversation = 500,
}

export type InstantMessageConversationRecipent = Readonly<{
  //deviceEndpoint: string
  endpointScheme: InstantMessagerParticipantEndpointScheme
  endpointId: string
  endpointServer: string
  //deviceEndpointProperties: string
  displayName: string
}>

export type InstantMessageConversationParticipant = Readonly<InstantMessageConversationRecipent & {
  endpointScheme: InstantMessagerParticipantEndpointScheme
  isCurrentUser: boolean
  participantId: string
  //isIMChatClientEnabled?: boolean
  sendInviteMessagesOnly: boolean
  status: InstantMessagerDeviceStatus
  state: InstantMessagerParticipantState
  //  invitedIntoConversation: boolean
  typing: boolean
}>


export type ConversationMessage = Readonly<{
  messageId: string
  message: string
}>

export enum EditAction {
  None = 0,
  Insert = 1,
  Edit = 2,
  Delete = 3,
  DeleteChildern = 4,
  StateUpdate = 5,
}
export enum EditResult {
  None = 0,
  NoChange = 1,
  DataStale = 2,
  Success = 3,
  AlreadyExist = 4,
  Fail = 5,
  MessageSent = 6,
  Timeout = 7,
  NoMessageCreated = 8
}

export enum RecurringTypes {
  None = 0,
  Once = 1,
  Daily = 2,
  Weekly = 3,
  Monthly = 4
}

export enum AcceptanceState {
  None = 0,
  JoinConference = 1,
  RecordName = 2,
  PinNumber = 3,
  Conferenced = 4,
  IncorrectPin = 5,
}

export type SearchEntity = Readonly<{
  number: string
  mobile: string
  home: string
  business: string
  other: string
  description: string
  dateTimeStart: number
  data: string[]
  matchedFieldType: MatchFieldType
  matchedValue: string
  email: string
  entityId: string
  entityType: EntityType
  entitySubType: ContactType
  entityServer: string
}>

export enum MatchFieldType {
  MatchNone = 0,
  MatchDescription = 1,
  MatchExtensionNumber = 2,
  MatchQueueNumber = 3,
  MatchMobileNumber = 4,
  MatchMobileNumberE164 = 5,
  MatchOtherNumber = 6,
  MatchOtherNumberE164 = 7,
  MatchHomeNumber = 8,
  MatchHomeNumberE164 = 9,
  MatchBusinessNumber = 10,
  MatchBusinessNumberE164 = 11,
  MatchMiscellaneousNumber = 12,
  MatchOfficeExtension = 13, //This is no longer as part of the search
  MatchEmail = 14,
  MatchJobTitle = 15,
  MatchDepartment = 16,
  MatchCompany = 17,
  MatchImAddress = 18,
  MatchPosition = 19,
  MatchExtensionSiteSpecific = 20
}

export enum ParagraphParticipantType {
  Unknown = 0,
  Extension = 1,
  Contact = 2
}

export type Transcription = Readonly<{
  //id: string
  sentiment: Sentiment
  neutral: number, negative: number, positive: number
  paragraphs: TranscriptionParagraph[]
  calls: TranscriptionCall[]
}>

export type TranscriptionCall = Readonly<{
  callId: string
  callTransactionId: string
  createdAtUtc: number
  modifiedAtUtc: number
  partyTypeId: ParagraphParticipantType
  displayName: string
  telephoneNumber: string

  extensionId?: string
  callKey: string
  contactId?: number
}>

export type TranscriptionParagraph = Readonly<{
  paragraphId: string
  callId: string
  createdAtUtc: number
  modifiedAtUtc: number
  modifiedBy: string
  text: string
  canEdit: boolean

  sentiment: Sentiment, neutral: number, negative: number, positive: number

  original?: string

  extensionId?: string
  displayName?: string
  contactId?: number
  telephoneNumber?: string

  tags?: CallBookmark[]
}>


export type CallBookmark = Readonly<{
  bookmarkId: string
  title: string
  timeStamp: number
  bookmarkTypeId: TagType
  createdBy: string
  createdAt: number
  modifiedBy: string
  modifiedAt: number
}>

export enum TagType {
  Normal = 0,
  Priority = 1,
}

export enum GosGraphType {
  Gos = 1,
  Depth = 2,
  Time = 3
}

export type GosLimit = Readonly<{
  queueId: string
  green: number
  red: number
  yellow: number
  type: GosGraphType
}>

export type Shortcut = (
  { entityType: EntityType.Contact } & ContactBasic |
  { entityType: EntityType.Extension } & Extension |
  { entityType: EntityType.Queue } & QueueStats
) & { groupListId: string, sort: number }
